export function getFirstSentence(text: string): string {
  if (!text) return '';
  const sentenceEnd = text.search(/[.!?]/);
  if (sentenceEnd === -1) {
    return text;
  }
  return text.substring(0, sentenceEnd + 1);
}
